module.exports = __webpack_public_path__ + "img/R2BE1E.ec628153.svg";